import { CustomerRoleEnum, CustomerPermissionEnum, CustomerRoleT } from '@/api/apis/customer';
import { RolesPermissions } from '@/types/permissions';

export const filterRoles = (roles: CustomerRoleT[]): CustomerRoleEnum[] => {
  return roles.filter((role): role is CustomerRoleEnum =>
    Object.values(CustomerRoleEnum).includes(role as CustomerRoleEnum),
  );
};

const filterPermissions = (roles: CustomerRoleT[]): CustomerPermissionEnum[] => {
  return roles.filter((role): role is CustomerPermissionEnum =>
    Object.values(CustomerPermissionEnum).includes(role as CustomerPermissionEnum),
  );
};

export const separateRolesAndPermissions = (roles: CustomerRoleT[] = []): RolesPermissions => {
  return {
    roles: filterRoles(roles),
    permissions: filterPermissions(roles),
  };
};

export const mergeRolesAndPermissions = (
  roles: CustomerRoleEnum[] = [],
  permissions: CustomerPermissionEnum[] = [],
): CustomerRoleT[] => {
  return [...roles, ...permissions];
};
